import * as actionTypes from "../actionTypes";

let ActionCreators = (data, actionType) => {
  return {
    type: actionTypes[actionType],
    payload: data,
  };
};

export const popupMessagesHandler = (messageObject) => {
  return ActionCreators(messageObject, "MESSAGES");
};

export const setLoading = (mode) => {
  return ActionCreators(mode, "LOADING");
};
export const set_multi_server_url = (mode) => {
  return ActionCreators(mode, "MULTI_SERVER_URL");
};
export const setLoading_MODAL = (mode) => {
  return ActionCreators(mode, "MODAL_LOADING");
};
export const setRegisterStart = (mode) => {
  return ActionCreators(mode, "REGISTER_INITIATED");
};

export const set_Refresh = (data) => {
  return ActionCreators(data, "REFRESH");
};
export const set_Let_Refresh = (mode) => {
  return ActionCreators(mode, "LET_REFRESH");
};
